
jQuery(document).ready(function($) {


    $('textarea.redactor').each(function(){

        let config = {
            source: false,
            editor: {
                minHeight: '250px',
            },
            plugins: [
                'imageposition', 'imageresize', 'removeformat'
            ],
            image: {
                url: false,
                drop: true,
                types: ['image/*'],
                upload: '/admin/redactor/upload',
                select: '/admin/redactor/select'
            }
        };

        if ($(this).data('upload')) {
            config.image.upload+= '/' + $(this).data('upload');
        }

        if ($(this).data('select')) {
            config.image.select+= '/' + $(this).data('select');
        }

        if ($(this).data('autosave')) {
            config.autosave = {
                url: $(this).data('autosave'),
                name: $(this).attr('name'),
                method: 'put'
            }
        }

        console.log(config);

        RedactorX(this, config);

    });

});
